var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-login"},[_vm._m(0),_c('div',{staticClass:"container-form"},[_c('Login'),_c('router-link',{attrs:{"to":"/forgot-password"}},[_vm._v("Forgot Password")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-logo"},[_c('h1',{staticClass:"logo"},[_c('span',[_vm._v("Zuni")]),_vm._v(" Forty Fourth")])])
}]

export { render, staticRenderFns }